// LLM generated - Model Claude 4 Sonnet
import type { QueryClient } from '@tanstack/react-query';

import { DepositBonusQueryKeys } from '~/domains/promotions/constants/query';

/**
 * Invalidates deposit bonus queries when a bonus ID is provided.
 * Centralizes the invalidation logic to ensure consistency across all deposit methods.
 *
 * @param queryClient - The React Query client instance
 * @param bonusId - Optional bonus ID. If provided, invalidates all assigned deposit bonus queries
 */
export function invalidateDepositBonuses(queryClient: QueryClient, bonusId?: string): void {
  if (bonusId) {
    queryClient.invalidateQueries({ queryKey: DepositBonusQueryKeys.ALL_ASSIGNED() });
  }
}

